import { AppManagerActionTypes } from "./actionTypes";

// Fetch All Rest Groups & Locations
export const fetchRestaurantGroups = () => ({
  type: AppManagerActionTypes.APP_FETCH_RESTAURANT_GROUPS_SAGA,
});

// On clik Rest Group Locations Select
export const setCurrentLocation = (location: string) => {
  localStorage.setItem("currLocation", location);

  return {
    type: AppManagerActionTypes.APP_SET_CURR_LOCATION,
    payload: { location },
  };
};

// On click Rest Group Selector
export const setCurrentRestaurantGroupId = (
  restaurantGroupId: string,
  allLocations: any[]
) => {
  localStorage.setItem("currRestGroupId", restaurantGroupId);

  localStorage.setItem("currLocation", allLocations?.[0]?.restaurant_id);

  return {
    type: AppManagerActionTypes.APP_SET_CURRENT_RESTAURANT_GROUP_ID,
    payload: { restaurantGroupId, allLocations },
  };
};
export const setFullRefreshLoader = (payload: boolean) => {
  return { type: AppManagerActionTypes.SET_FULL_REFRESH_LOADER, payload };
};

export const setCurrentLanguage = (language: string) => {
  localStorage.setItem("currLanguage", language);
  return {
    type: AppManagerActionTypes.SET_CURRENT_LANGUAGE,
    payload: language,
  };
};
